// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── WhatsApp Floating Support Button ── */

@keyframes wa-fade-up {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes wa-pulse {
  0% {
    box-shadow:
      0 8px 32px rgba(37, 211, 102, 0.35),
      0 2px 10px rgba(0, 0, 0, 0.14),
      0 0 0 0 rgba(37, 211, 102, 0.45);
  }
  60% {
    box-shadow:
      0 8px 32px rgba(37, 211, 102, 0.35),
      0 2px 10px rgba(0, 0, 0, 0.14),
      0 0 0 14px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow:
      0 8px 32px rgba(37, 211, 102, 0.35),
      0 2px 10px rgba(0, 0, 0, 0.14),
      0 0 0 0 rgba(37, 211, 102, 0);
  }
}

@keyframes wa-tooltip-fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── Wrapper ── */
.wa-wrapper {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1300;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  pointer-events: none;
}

/* ── Tooltip ── */
.wa-tooltip {
  background: rgba(20, 20, 20, 0.88);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: 0.01em;
  padding: 7px 14px;
  border-radius: 20px;
  white-space: nowrap;
  pointer-events: none;
  animation: wa-tooltip-fade 0.35s ease forwards;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* ── Button ── */
.wa-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 22px;
  background: linear-gradient(135deg, #2ce97b 0%, #25d366 40%, #128c7e 100%);
  border-radius: 50px;
  border: none;
  outline: none;
  cursor: pointer;
  pointer-events: auto;
  color: #fff;
  text-decoration: none;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.015em;
  line-height: 1;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;

  /* Entry animation */
  animation: wa-fade-up 0.5s cubic-bezier(0.34, 1.2, 0.64, 1) both,
    wa-pulse 2.8s 1.2s ease-out infinite;

  /* Base shadow */
  box-shadow:
    0 8px 32px rgba(37, 211, 102, 0.35),
    0 2px 10px rgba(0, 0, 0, 0.14);

  transition:
    transform 0.22s cubic-bezier(0.34, 1.3, 0.64, 1),
    box-shadow 0.22s ease;

  /* Subtle inner glass highlight */
  position: relative;
  overflow: hidden;
}

.wa-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.18) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 50px 50px 0 0;
  pointer-events: none;
}

.wa-button:hover {
  transform: scale(1.06) translateY(-3px);
  box-shadow:
    0 16px 48px rgba(37, 211, 102, 0.45),
    0 4px 16px rgba(0, 0, 0, 0.16);
  animation: wa-fade-up 0.5s cubic-bezier(0.34, 1.2, 0.64, 1) both; /* stop pulse on hover */
}

.wa-button:active {
  transform: scale(0.97) translateY(0);
  box-shadow:
    0 4px 16px rgba(37, 211, 102, 0.3),
    0 1px 4px rgba(0, 0, 0, 0.12);
}

.wa-button:focus-visible {
  outline: 3px solid rgba(37, 211, 102, 0.6);
  outline-offset: 3px;
}

/* ── Icon ── */
.wa-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
}

/* ── Text ── */
.wa-text {
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.015em;
}

/* ── Mobile ── */
@media (max-width: 600px) {
  .wa-wrapper {
    bottom: 20px;
    right: 18px;
  }

  .wa-button {
    width: 56px;
    height: 56px;
    padding: 0;
    border-radius: 50%;
    justify-content: center;
    gap: 0;
  }

  .wa-text {
    display: none;
  }

  .wa-tooltip {
    font-size: 12px;
    padding: 6px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/whatsapp/WhatsAppButton.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE;;;sCAGkC;EACpC;EACA;IACE;;;sCAGkC;EACpC;EACA;IACE;;;mCAG+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;EACX,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;;EAExC,oBAAoB;EACpB;wCACsC;;EAEtC,gBAAgB;EAChB;;kCAEgC;;EAEhC;;yBAEuB;;EAEvB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;GAIC;EACD,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC;;kCAEgC;EAChC,gEAAgE,EAAE,wBAAwB;AAC5F;;AAEA;EACE,oCAAoC;EACpC;;iCAE+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,MAAM;EACR;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* ── WhatsApp Floating Support Button ── */\n\n@keyframes wa-fade-up {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes wa-pulse {\n  0% {\n    box-shadow:\n      0 8px 32px rgba(37, 211, 102, 0.35),\n      0 2px 10px rgba(0, 0, 0, 0.14),\n      0 0 0 0 rgba(37, 211, 102, 0.45);\n  }\n  60% {\n    box-shadow:\n      0 8px 32px rgba(37, 211, 102, 0.35),\n      0 2px 10px rgba(0, 0, 0, 0.14),\n      0 0 0 14px rgba(37, 211, 102, 0);\n  }\n  100% {\n    box-shadow:\n      0 8px 32px rgba(37, 211, 102, 0.35),\n      0 2px 10px rgba(0, 0, 0, 0.14),\n      0 0 0 0 rgba(37, 211, 102, 0);\n  }\n}\n\n@keyframes wa-tooltip-fade {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ── Wrapper ── */\n.wa-wrapper {\n  position: fixed;\n  bottom: 28px;\n  right: 28px;\n  z-index: 1300;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n  pointer-events: none;\n}\n\n/* ── Tooltip ── */\n.wa-tooltip {\n  background: rgba(20, 20, 20, 0.88);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  color: #fff;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 12.5px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  padding: 7px 14px;\n  border-radius: 20px;\n  white-space: nowrap;\n  pointer-events: none;\n  animation: wa-tooltip-fade 0.35s ease forwards;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* ── Button ── */\n.wa-button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 22px;\n  background: linear-gradient(135deg, #2ce97b 0%, #25d366 40%, #128c7e 100%);\n  border-radius: 50px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  pointer-events: auto;\n  color: #fff;\n  text-decoration: none;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.015em;\n  line-height: 1;\n  white-space: nowrap;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n\n  /* Entry animation */\n  animation: wa-fade-up 0.5s cubic-bezier(0.34, 1.2, 0.64, 1) both,\n    wa-pulse 2.8s 1.2s ease-out infinite;\n\n  /* Base shadow */\n  box-shadow:\n    0 8px 32px rgba(37, 211, 102, 0.35),\n    0 2px 10px rgba(0, 0, 0, 0.14);\n\n  transition:\n    transform 0.22s cubic-bezier(0.34, 1.3, 0.64, 1),\n    box-shadow 0.22s ease;\n\n  /* Subtle inner glass highlight */\n  position: relative;\n  overflow: hidden;\n}\n\n.wa-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 50%;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.18) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  border-radius: 50px 50px 0 0;\n  pointer-events: none;\n}\n\n.wa-button:hover {\n  transform: scale(1.06) translateY(-3px);\n  box-shadow:\n    0 16px 48px rgba(37, 211, 102, 0.45),\n    0 4px 16px rgba(0, 0, 0, 0.16);\n  animation: wa-fade-up 0.5s cubic-bezier(0.34, 1.2, 0.64, 1) both; /* stop pulse on hover */\n}\n\n.wa-button:active {\n  transform: scale(0.97) translateY(0);\n  box-shadow:\n    0 4px 16px rgba(37, 211, 102, 0.3),\n    0 1px 4px rgba(0, 0, 0, 0.12);\n}\n\n.wa-button:focus-visible {\n  outline: 3px solid rgba(37, 211, 102, 0.6);\n  outline-offset: 3px;\n}\n\n/* ── Icon ── */\n.wa-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n}\n\n/* ── Text ── */\n.wa-text {\n  color: #fff;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.015em;\n}\n\n/* ── Mobile ── */\n@media (max-width: 600px) {\n  .wa-wrapper {\n    bottom: 20px;\n    right: 18px;\n  }\n\n  .wa-button {\n    width: 56px;\n    height: 56px;\n    padding: 0;\n    border-radius: 50%;\n    justify-content: center;\n    gap: 0;\n  }\n\n  .wa-text {\n    display: none;\n  }\n\n  .wa-tooltip {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
